import { ENDPOINTS } from '@shared/constants';
import { UserRole, type PurchaseOrderAction, type PurchaseOrderWithRelations } from '@shared/types';

export interface PurchaseOrderHttpClient {
  post: (url: string, body?: unknown) => Promise<unknown>;
  patch: (url: string, body?: unknown) => Promise<unknown>;
}

export function createPurchaseOrderTransport(client: PurchaseOrderHttpClient) {
  return {
    generateFromSelectedSuggestions(suggestionIds: string[]) {
      return client.post(ENDPOINTS.predictions.generatePo, { suggestionIds });
    },
    update(id: string, data: unknown) {
      return client.patch(ENDPOINTS.purchaseOrders.update(id), data);
    },
  };
}

/**
 * Whether a role may perform a PO action, matching the server matrix:
 * receive needs purchase_orders:receive (A/M/O); send, confirm and cancel
 * need purchase_orders:update (A/M).
 */
export function canUsePurchaseOrderAction(
  role: UserRole | undefined | null,
  action: PurchaseOrderAction
): boolean {
  if (role === UserRole.ADMIN || role === UserRole.MANAGER) return true;
  return action === 'receive' && role === UserRole.OPERATOR;
}

/** The server offers the action for this PO's status, and the role may use it. */
export function hasPurchaseOrderAction(
  po: PurchaseOrderWithRelations,
  action: PurchaseOrderAction,
  role: UserRole | undefined | null
): boolean {
  return (po.nextActions?.includes(action) ?? false) && canUsePurchaseOrderAction(role, action);
}
